import { useCallback, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import Modal from "../../components/Modal";
import { InfoType } from "../../reducer/userpayloadtypes";

export default function Regist() {
  const navigate = useNavigate();

  const [info, setInfo] = useState<InfoType>({
    name: "",
    id: "",
    password: "",
    confirmpassword: "",
    belong: "",
  });
  const [signupModal, setSignupModal] = useState<boolean>(false);

  const onChangefunc = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setInfo({ ...info, [e.target.name]: e.target.value });
    },
    [info]
  );

  const modalfunc = useCallback(
    (type: string) => {
      if (type === "signupModal") {
        setSignupModal(true);
      }
    },
    [signupModal]
  );

  const postfunc = useCallback(
    async (type: string) => {
      console.log("info:", info);

      if (type === "YES") {
        if (info.password !== info.confirmpassword) {
          return alert("비밀번호가 일치하지 않습니다.");
        }
      } else if (type === "NO") {
        setSignupModal(false);
      }
    },
    [signupModal, info]
  );

  return (
    <div className="login-container 12">
      <div className="login-box">
        <div className="login-img-box">
          <img src="/img/logo.svg" />
        </div>
        <div className="login-form-box">
          <div className="login-form">
            <p>이름</p>
            <input
              type="name"
              id="name"
              name="name"
              placeholder="이름"
              value={info.name}
              onChange={onChangefunc}
            />
          </div>
          <div className="login-form">
            <p>아이디</p>
            <input
              type="id"
              id="id"
              name="id"
              placeholder="비밀번호"
              value={info.id}
              onChange={onChangefunc}
            />
          </div>

          <div className="login-form">
            <p>비밀번호</p>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="비밀번호"
              value={info.password}
              onChange={onChangefunc}
            />
          </div>
          <div className="login-form">
            <p>비밀번호확인</p>
            <input
              type="password"
              id="confirmpassword"
              name="confirmpassword"
              placeholder="비밀번호"
              value={info.confirmpassword}
              onChange={onChangefunc}
            />
          </div>

          <div className="login-form">
            <p>소속</p>
            <input
              type="belong"
              id="belong"
              name="belong"
              placeholder="소속"
              value={info.belong}
              onChange={onChangefunc}
            />
          </div>

          <div className="btn-style-box">
            <div
              className="btn-style-1"
              onClick={() => modalfunc("signupModal")}
            >
              확인
            </div>
            <div className="btn-style-1 bg-gray" onClick={() => navigate(-1)}>
              취소
            </div>
          </div>
        </div>
      </div>
      {signupModal && (
        <Modal
          title={"회원가입 하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => postfunc("YES")}
          secondclick={() => postfunc("NO")}
        />
      )}
    </div>
  );
}
